import(/* webpackMode: "eager" */ "/app/apps/pages/src/app/global-error.tsx");
